<div class="modal-header">
  <div class="container-fluid modal-title">
      <div class="row">
          <div class="col-11">
              <h3>{{subject}}</h3>
              <br />
              <em>{{signature}}</em>
          </div>

          <div class="col-1">
              <a class="link-hover font-weight-light" (click)="close()">
                  <i class="fa-regular fa-xmark mr-2" title="Stäng"></i>
              </a>
          </div>
      </div>

  </div>
</div>

<div class="modal-body">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12" [innerHTML]="message"></div>
      </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-primary" (click)="close()">Stäng</button>
</div>

